import React, { lazy } from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function ContactSection() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Formulario enviado. Nos pondremos en contacto pronto.');
  };
  return <section id="contacto" className="bg-white py-24 relative overflow-hidden" data-id="element-51">
      {/* Subtle background image */}
      <div className="absolute inset-0 bg-cover bg-center opacity-[0.03]" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/cRngAU39Vt1d5A8yeyLqz4/heylloyd-image-1774620675613.png')"
    }} data-id="element-52"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="text-center mb-16" data-id="element-54">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-55">
            Contacta con nosotros
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 bg-gradient-to-r from-blue-600 to-red-500 rounded-full" data-id="element-56"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-57">
            Pide tu cita o solicita presupuesto sin compromiso. Estamos aquí
            para ayudarte.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-58">
          {/* Contact Form */}
          <div className="bg-gray-50 rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-59">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-60">
              Envíanos un mensaje
            </h3>
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-61">
              <div data-id="element-62">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-63">
                  Nombre completo
                </label>
                <input type="text" id="name" name="name" required className="w-full rounded-md border border-gray-300 px-4 py-3 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20 transition-colors" placeholder="Tu nombre" data-id="element-64" />
              </div>

              <div data-id="element-65">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-66">
                  Teléfono
                </label>
                <input type="tel" id="phone" name="phone" required className="w-full rounded-md border border-gray-300 px-4 py-3 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20 transition-colors" placeholder="Tu número de teléfono" data-id="element-67" />
              </div>

              <div data-id="element-68">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-69">
                  Mensaje o consulta
                </label>
                <textarea id="message" name="message" rows={4} required className="w-full rounded-md border border-gray-300 px-4 py-3 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20 transition-colors resize-none" placeholder="¿En qué podemos ayudarte?" data-id="element-70"></textarea>
              </div>

              <button type="submit" className="w-full rounded-md bg-blue-600 px-6 py-4 text-base font-bold text-white shadow-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-71">
                Reserva tu cita ahora
              </button>
            </form>
          </div>

          {/* Contact Info & Workshop Image */}
          <div className="flex flex-col justify-between" data-id="element-72">
            <div className="space-y-8" data-id="element-73">
              <div className="flex items-start" data-id="element-74">
                <div className="flex-shrink-0 bg-blue-100 p-3 rounded-full" data-id="element-75">
                  <PhoneIcon className="h-6 w-6 text-blue-600" data-id="element-76" />
                </div>
                <div className="ml-4" data-id="element-77">
                  <h4 className="text-lg font-bold text-gray-900" data-id="element-78">Llámanos</h4>
                  <a href="tel:643506719" className="mt-1 block text-3xl font-extrabold text-blue-600 hover:text-blue-700 transition-colors" data-id="element-79">
                    643 506 719
                  </a>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-80">
                    Atención inmediata
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-81">
                <div className="flex-shrink-0 bg-gray-100 p-3 rounded-full" data-id="element-82">
                  <MapPinIcon className="h-6 w-6 text-gray-600" data-id="element-83" />
                </div>
                <div className="ml-4" data-id="element-84">
                  <h4 className="text-lg font-bold text-gray-900" data-id="element-85">Ubicación</h4>
                  <p className="mt-1 text-gray-600" data-id="element-86">
                    Calle El Postiguillo, 5, Nave 522
                    <br data-id="element-87" />
                    Pol. Ind. Valmor
                    <br data-id="element-88" />
                    28341 Valdemoro, Madrid
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-89">
                <div className="flex-shrink-0 bg-gray-100 p-3 rounded-full" data-id="element-90">
                  <ClockIcon className="h-6 w-6 text-gray-600" data-id="element-91" />
                </div>
                <div className="ml-4" data-id="element-92">
                  <h4 className="text-lg font-bold text-gray-900" data-id="element-93">Horario</h4>
                  <p className="mt-1 text-gray-600" data-id="element-94">
                    Lunes a Viernes: 9:00 - 19:00
                    <br data-id="element-95" />
                    Sábados: 9:00 - 14:00
                  </p>
                </div>
              </div>
            </div>

            {/* Google Maps embed */}
            <div className="mt-10 h-64 w-full rounded-xl overflow-hidden shadow-lg border border-gray-200" data-id="element-96">
              <iframe title="Ubicación KDLR Talleres S.L" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3045.5!2d-3.6745!3d40.1905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sCalle+El+Postiguillo%2C+5%2C+Nave+522%2C+Pol.+Ind.+Valmor%2C+28341+Valdemoro%2C+Madrid!5e0!3m2!1ses!2ses!4v1700000000000" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-97"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>;
}